import {HumidifierActionTypes} from 'constants/actionType';

export const setIsHumidifierInstalled = (isHumidifierInstalled) => ({
  type: HumidifierActionTypes.SET_IS_HUMIDIFIER_INSTALLED,
  data: isHumidifierInstalled,
});

export const setIdleHumidity = (idleHumidity) => ({
  type: HumidifierActionTypes.SET_IDLE_HUMIDITY,
  data: idleHumidity,
});

export const setIsIdleHumidityEnabled = (isIdleHumidityEnabled) => ({
  type: HumidifierActionTypes.SET_IS_IDLE_HUMIDITY_ENABLED,
  data: isIdleHumidityEnabled,
});

export const setHumidifierDoorStatus = (humidifierDoorStatus) => ({
  type: HumidifierActionTypes.SET_HUMIDIFIER_DOOR_STATUS,
  data: humidifierDoorStatus,
});

export const setHumidifierRuntime = (humidifierRuntime) => ({
  type: HumidifierActionTypes.SET_HUMIDIFIER_RUNTIME,
  data: humidifierRuntime,
});

export const setHumidifierError = (humidifierError) => ({
  type: HumidifierActionTypes.SET_HUMIDIFIER_ERROR,
  data: humidifierError,
});

export const setIsWaterLevelLow = (isWaterLevelLow) => ({
  type: HumidifierActionTypes.SET_IS_WATER_LEVEL_LOW,
  data: isWaterLevelLow,
});

export const setIsHumidifierConnected = (isHumidifierConnected) => ({
  type: HumidifierActionTypes.SET_IS_HUMIDIFIER_CONNECTED,
  data: isHumidifierConnected,
});
